import {Component, HostBinding} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {GenericLinkedResource} from '@catcore/types/base';
import {GenericResourceService} from '@catfeatures/services/generic-resource.service';
import {ResourceHandler} from '@catfeatures/types';
import {CreatePortConnectionComponent} from '@catmodules/models/feature-port/components/create-port-connection/create-port-connection.component';
import {ModifyPortConnectionComponent} from '@catmodules/models/feature-port/components/modify-port-connection/modify-port-connection.component';
import {FeaturePortService} from '@catmodules/models/feature-port/services/feature-port.service';
import {FeaturePort, FeaturePortConnection, FeaturePortConnectionCreateInfo} from '@catmodules/models/feature-port/types';
import {ModalService} from '@catmodules/widgets/slide-in-modal/services/modal.service';
import {DisplayTypes} from '@catui/components/panel/types';
import {LinkItem, StyleType} from '@catui/types';
import {EntityForm} from '@catuimodels/shared/entity-form';
import {isNullOrUndefined} from 'util';

const componentBaseName = 'feature-port-form';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-feature-port-form',
  styleUrls: ['./feature-port-form.component.scss'],
  templateUrl: './feature-port-form.component.html',
})
export class FeaturePortFormComponent extends EntityForm {
  @HostBinding('class') classNames = defaultClassNames;

  labels = {
    virtual: 'Is virtual',
    alphaNumericPosition: 'Alpha numeric position',
    isInput: 'Is input',
    isOutput: 'Is output',
    portType: 'Port Type',
  };

  styleType = StyleType;
  PanelDisplayTypes = DisplayTypes;

  featurePort: FeaturePort;
  currentFeaturePortHandler: ResourceHandler;
  portConnection1Items: LinkItem[] = [];
  portConnection2Items: LinkItem[] = [];

  get canCreateNew() {
    let isValid = false;

    if (!isNullOrUndefined(this.featurePort)) {
      isValid = this.featurePort.output ||
        !this.featurePortService.hasIncomingPortConnection(this.featurePort);
    }

    return isValid;
  }

  get portConnectionItems(): LinkItem[] {
    return [...this.portConnection1Items, ...this.portConnection2Items];
  }

  constructor(formBuilder: FormBuilder,
              private modalService: ModalService,
              private genericResourceService: GenericResourceService,
              private featurePortService: FeaturePortService) {
    super(formBuilder);
    this.setUpdateIgnore(['virtual']);

  }

  afterUpdateForm() {
    const model = this.getModel();
    this.featurePort = model;
    this.currentFeaturePortHandler = this.genericResourceService.findServiceForResource(this.featurePort._links.self.href);
    const portConnections1 = this.featurePortService.extractPortConnections1(model);
    const portConnections2 = this.featurePortService.extractPortConnections2(model);
    this.updatePortConnection1Options(portConnections1);
    this.updatePortConnection2Options(portConnections2);
  }

  openCreateDialog() {
    const compRef = this.modalService.open(CreatePortConnectionComponent);
    const onFullfill = (portConnection: FeaturePortConnection) => {
      console.log('update portConnection2 for current FeaturePort');
    };

    const onError = () => {
    };

    compRef.componentInstance.title = `New Port Connection`;
    compRef.componentInstance.source = this.getModel();
    compRef.componentInstance.afterCreate
      .subscribe((portConnection: FeaturePortConnection) => {
        this.refresh();
        // this
        //   .updatePortConnection2(portConnection)
        //   .subscribe((value: any) => {
        //     console.log('port connecton 2 was assigned');
        //     this.refresh();
        //
        //   });
      });

    compRef.result.then(onFullfill, onError);

  }

  private updatePortConnection2(portConnection: FeaturePortConnection) {
    return this
      .featurePortService
      .update({
        id: this.getModel().id,
        port_connection_type2: portConnection._links.self.href,
      });
  }

  private updatePortConnection1Options(portConnections: GenericLinkedResource[]): void {
    this.portConnection1Items = this.buildOptionsFromLinkedResources(portConnections);
  }

  private updatePortConnection2Options(portConnections: GenericLinkedResource[]): void {
    this.portConnection2Items = this.buildOptionsFromLinkedResources(portConnections);
  }

  private openModifyDialog(resource: GenericLinkedResource) {
    let compRef;
    const onFullfill = (value: any) => {
      console.log('closed create modal');
    };

    const onError = () => {
    };

    const resourceHandler = this
      .genericResourceService
      .findServiceForResource(resource.href);

    resourceHandler
      .getCurrent()
      .subscribe((portConnection: FeaturePortConnectionCreateInfo) => {
        if (compRef) {
          compRef.close();
          compRef = null;
        }

        if (isNullOrUndefined(portConnection)) {
          compRef = null;
        } else {
          compRef = this.modalService.open(ModifyPortConnectionComponent);
          compRef.componentInstance.model = portConnection;
          compRef.componentInstance.title = `Modify Port Connection`;
          compRef.componentInstance.source = this.getModel();
          compRef.componentInstance.afterUpdate.subscribe(() => this.refresh());
          compRef.componentInstance.afterDelete.subscribe(() => this.refresh());
          compRef.result.then(onFullfill, onError);
        }
      });

    if (!resourceHandler.isReady()) {
      resourceHandler.load();
    }

  }

  private refresh() {
    this.currentFeaturePortHandler.refresh();
  }

  private buildOptionsFromLinkedResources(items: GenericLinkedResource[]): LinkItem[] {
    const options: LinkItem[] = [];
    items.forEach((item: GenericLinkedResource) => options.push({
      label: item.label,
      navigate: () => {
        this.openModifyDialog(item);
      },
    }));
    return options;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/feature-port/components/feature-port-form/feature-port-form.component.ts